import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../component/layout';
import ActiveLeviesTab from './ActiveLeviesTab';
import InactiveLeviesTab from './InactiveLeviesTab';

const ContractManagement = () => {
    const [activeTab, setActiveTab] = useState('active');

    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/facility/">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">Levy Management</li>
                                <li className="breadcrumb-item">Levy Details</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <h5>Levy Details</h5>
                        </div>
                        <div className="card-body">

                            <ul className="nav nav-tabs mb-3">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('active')}
                                    >
                                        Active Levies
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'inactive' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('inactive')}
                                    >
                                        Inactive Levies
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content">
                                {activeTab === 'active'   && <ActiveLeviesTab />}
                                {activeTab === 'inactive' && <InactiveLeviesTab />}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ContractManagement;